import React from 'react';
import { FilterIcon } from '../../helpers/Icons';

const PortfolioTabs = ({
  activeTab,
  counts,
  historyFiltersOpen,
  onChange,
  onToggleHistoryFilters,
  theme,
}) => {
  const TabBtn = ({ id, label, count }) => (
    <button onClick={() => onChange(id)} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: theme.sans, background: activeTab === id ? `${theme.primary}15` : 'transparent', color: activeTab === id ? theme.primary : theme.textS, position: 'relative', transition: 'background 0.12s ease, color 0.12s ease' }}>
      {label}
      {count > 0 && <span style={{ fontSize: 10, fontWeight: 700, color: activeTab === id ? theme.primary : '#fff', background: activeTab === id ? `${theme.primary}22` : theme.textM, padding: '1px 5px', borderRadius: 6, marginLeft: 6 }}>{count}</span>}
      {activeTab === id && <div style={{ position: 'absolute', bottom: 0, left: '20%', right: '20%', height: 2, background: theme.primary, borderRadius: '2px 2px 0 0' }} />}
    </button>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '8px 12px', borderBottom: `1px solid ${theme.border}` }}>
      <TabBtn id="positions" label="Positions" count={counts.positions} />
      <TabBtn id="pending" label="Pending" count={counts.pending} />
      <TabBtn id="history" label="History" count={counts.history} />
      {activeTab === 'history' && (
        <button
          aria-label="Toggle history filters"
          title="Filter history"
          onClick={onToggleHistoryFilters}
          style={{
            width: 30,
            height: 30,
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${historyFiltersOpen ? theme.primary : theme.border}`,
            borderRadius: 6,
            cursor: 'pointer',
            background: historyFiltersOpen ? `${theme.primary}15` : 'transparent',
            color: historyFiltersOpen ? theme.primary : theme.textS,
            transition: 'background 0.12s ease, color 0.12s ease, border-color 0.12s ease',
          }}
        >
          <FilterIcon s={15} />
        </button>
      )}
    </div>
  );
};

export default React.memo(PortfolioTabs);
